import { useEffect, useState } from "react";
import { Position, api, isError } from "../api";
import { useBridgePoll } from "./useBridgePoll";

const POLL_MS = 2000;

export function usePositionsPoll() {
  const [positions, setPositions] = useState<Position[]>([]);
  const bridge = useBridgePoll();

  useEffect(() => {
    let cancelled = false;
    async function tick() {
      const p = await api.accountPositions();
      if (cancelled) return;
      setPositions(isError(p) ? [] : p.positions);
    }
    void tick();
    const id = setInterval(tick, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return { positions, bridgeConnected: !!bridge?.connected };
}
